import script from "./AboutDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutDialog.vue?vue&type=script&setup=true&lang=js"

import "./AboutDialog.vue?vue&type=style&index=0&id=52ee1a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ee1a00"]])

export default __exports__